import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../core/form/TextInput';
import Button from '../../../core/form/Button';
import Column from '../../../core/layout/Column';
import Row from '../../../core/layout/Row';
import Select from '../../../core/form/Select';
import LocaleSelect from '../../../core/form/LocaleSelect';
import { get } from 'lodash';

const InstructionAudioListFilter = (props) => (
  <Row>
    <Column size={1.5}>
      <Select
        options={[
          {
            label: 'All',
            value: 'ALL',
          },
          {
            label: 'Student',
            value: 'STUDENT',
          },
          {
            label: 'Kids',
            value: 'KIDS',
          },
          {
            label: 'Parents',
            value: 'PARENTS',
          },
        ]}
        label="Type"
        value={get(props.values, 'type')}
        onChange={(value) => props.onChange('type', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={2.5}>
      <TextInput
        label="Search by key"
        value={get(props.values, 'key')}
        onChange={(value) => props.onChange('key', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={2.5}>
      <TextInput
        label="Search by text"
        value={get(props.values, 'text')}
        onChange={(value) => props.onChange('text', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={1.5}>
      <LocaleSelect
        label="Missing text for key"
        value={get(props.values, 'localeMissingText')}
        onChange={(value) => props.onChange('localeMissingText', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={1.5}>
      <LocaleSelect
        label="Missing audio file for key"
        value={get(props.values, 'localeMissingAudio')}
        onChange={(value) => props.onChange('localeMissingAudio', value)}
        disabled={props.fetching}
      />
    </Column>
    <Column size={2}>
      <div style={{ height: 42 }} />
      <Button label="Search" icon="search" onClick={props.onSearch} />
    </Column>
  </Row>
);

InstructionAudioListFilter.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
};

InstructionAudioListFilter.defaultProps = {
  fetching: false,
};

export default InstructionAudioListFilter;
